export default __webpack_public_path__ + "static/media/stock5.b9cb82de.jpg";